<template>
	<div class="image-display-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<div class="flex-centerize">
			<img :src="imageDisplayUrl" />
		</div>
	</div>
</template>

<script>
import WidgetFieldMixin from '../WidgetFieldMixin';
import DefaultWidgetField from '../DefaultWidgetField';
import WidgetFormService from '@/components/WidgetForm/WidgetFormService';

export default {
	name: 'ImageDisplayField',
	components: {
		DefaultWidgetField,
	},
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	mixins: [WidgetFieldMixin],
	computed: {
		imageDisplayUrl() {
			return this.translatePreviousStepsValue(this.fieldOptions.image_display_url);
		},
	},
	methods: {
		translatePreviousStepsValue(value) {
			return this.previousSteps
				? WidgetFormService.processPreviousSteps(
						value,
						this.previousSteps,
						this.replaceInsertDataStringDict,
						this.configurationsMappingBlocksUUIDs
				  )
				: value;
		},
	},
};
</script>

<style scoped lang="scss">
.image-display-field {
	img {
		max-width: 100%;
	}
}
</style>
